"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.regexp.replace");

var _slicedToArray = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BasicAuth;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _qrcode = _interopRequireDefault(require("qrcode.react"));

var _Button = _interopRequireDefault(require("@arcblock/ux/lib/Button"));

var _Download = _interopRequireDefault(require("@arcblock/ux/lib/Wallet/Download"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _useBrowser = _interopRequireDefault(require("@arcblock/react-hooks/lib/useBrowser"));

var _success = _interopRequireDefault(require("./assets/success"));

var _locale = _interopRequireDefault(require("./assets/locale"));

var _token = _interopRequireDefault(require("./hooks/token"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // eslint-disable-next-line object-curly-newline


function BasicAuth(_ref) {
  var onClose = _ref.onClose,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      action = _ref.action,
      locale = _ref.locale,
      prefix = _ref.prefix,
      socketUrl = _ref.socketUrl,
      tokenKey = _ref.tokenKey,
      messages = _ref.messages,
      checkFn = _ref.checkFn,
      checkInterval = _ref.checkInterval,
      checkTimeout = _ref.checkTimeout,
      qrcodeSize = _ref.qrcodeSize,
      extraParams = _ref.extraParams,
      disableClose = _ref.disableClose,
      showDownload = _ref.showDownload,
      rest = _objectWithoutProperties(_ref, ["onClose", "onSuccess", "onError", "action", "locale", "prefix", "socketUrl", "tokenKey", "messages", "checkFn", "checkInterval", "checkTimeout", "qrcodeSize", "extraParams", "disableClose", "showDownload"]);

  if (typeof checkFn !== 'function') {
    throw new Error('Cannot initialize did auth component without a fetchFn');
  }

  if (!_locale["default"][locale]) {
    // eslint-disable-next-line no-param-reassign
    locale = 'en';
  }

  var browser = (0, _useBrowser["default"])();

  var _react$default$useSta = _react["default"].useState(null),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      jsBridge = _react$default$useSta2[0],
      setJsBridge = _react$default$useSta2[1];

  var _ref2 = (0, _token["default"])({
    action: action,
    checkFn: checkFn,
    checkInterval: checkInterval,
    checkTimeout: checkTimeout,
    extraParams: extraParams,
    locale: locale,
    prefix: prefix,
    socketUrl: socketUrl,
    tokenKey: tokenKey,
    onClose: onClose,
    onError: onError,
    onSuccess: onSuccess
  }),
      _ref3 = _slicedToArray(_ref2, 3),
      state = _ref3[0],
      generate = _ref3[1],
      cancel = _ref3[2];

  var _react$default$useSta3 = _react["default"].useState(false),
      _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
      isNativeCalled = _react$default$useSta4[0],
      setNativeCalled = _react$default$useSta4[1];

  var getDeepLink = function getDeepLink() {
    if (!state.url) {
      return '';
    }

    var deepLink = state.url;

    if (browser.mobile.any) {
      deepLink = deepLink.replace(/^https?:\/\//, 'abt://');
      var callbackUrl = window.location.href;

      if (callbackUrl.indexOf('?') > 0) {
        callbackUrl += "&".concat(tokenKey, "=").concat(state.token);
      } else {
        callbackUrl += "?".concat(tokenKey, "=").concat(state.token);
      }

      callbackUrl = encodeURIComponent(callbackUrl);

      if (deepLink.indexOf('?') > 0) {
        deepLink += "&callback=".concat(callbackUrl, "&callback_delay=1500");
      } else {
        deepLink += "?callback=".concat(callbackUrl, "&callback_delay=1500");
      }
    }

    return deepLink;
  };

  var onGenerate = function onGenerate() {
    setNativeCalled(false);
    generate();
  };

  _react["default"].useEffect(function () {
    if (!jsBridge) {
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('dsbridge'));
      }).then(function (x) {
        return setJsBridge(x);
      });
    }
  }, [browser]);

  _react["default"].useEffect(function () {
    var deepLink = getDeepLink();

    if (state.status === 'created' && deepLink && !isNativeCalled) {
      jsBridge.call('authAction', {
        action: 'auth',
        deepLink: deepLink
      });
      setNativeCalled(true);
    }
  }, [state]);

  var className = "auth-section auth-section--".concat(state.status).trim();
  var downLoadTitle = locale === 'zh' ? '还没安装 ABT Wallet，猛击下面的链接下载：' : "Don't have the ABT Wallet app? Get it now:";

  if (state.loading) {
    return _react["default"].createElement(Container, Object.assign({
      disableClose: disableClose
    }, rest), _react["default"].createElement("div", {
      className: className
    }, _react["default"].createElement(_CircularProgress["default"], null)));
  }

  if (['created', 'timeout'].includes(state.status)) {
    // If in ABT Wallet, just show the progress indicator, since we are calling native js bridge
    if (browser.wallet) {
      return _react["default"].createElement(Container, Object.assign({
        disableClose: disableClose
      }, rest), _react["default"].createElement("div", {
        className: "auth-close",
        onClick: cancel
      }, "\xD7"), _react["default"].createElement("div", {
        className: className
      }, _react["default"].createElement(_CircularProgress["default"], null)));
    }

    return _react["default"].createElement(Container, Object.assign({
      disableClose: disableClose
    }, rest), _react["default"].createElement(_Typography["default"], {
      component: "h3",
      variant: "h6",
      className: showDownload ? 'auth-title auth-title-center' : 'auth-title',
      title: messages.title
    }, messages.title), _react["default"].createElement("div", {
      className: "auth-close",
      onClick: cancel
    }, "\xD7"), _react["default"].createElement("div", {
      className: className
    }, _react["default"].createElement(_Typography["default"], {
      component: "div",
      className: showDownload ? 'auth-tip auth-tip--scan auth-tip--scan-center' : 'auth-tip auth-tip--scan',
      title: messages.scan
    }, messages.scan), _react["default"].createElement("div", {
      className: "auth-qrcode auth-qrcode--".concat(state.status)
    }, _react["default"].createElement("div", {
      className: "auth-qrcode-area",
      style: {
        width: "".concat(qrcodeSize, "px"),
        height: "".concat(qrcodeSize, "px")
      }
    }, _react["default"].createElement(_qrcode["default"], {
      size: qrcodeSize,
      renderAs: "svg",
      level: "M",
      value: state.url
    }), showDownload && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("i", {
      className: "base-line left-top-v-line"
    }), _react["default"].createElement("i", {
      className: "base-line left-top-h-line"
    }), _react["default"].createElement("i", {
      className: "base-line right-top-v-line"
    }), _react["default"].createElement("i", {
      className: "base-line right-top-h-line"
    }), _react["default"].createElement("i", {
      className: "base-line left-bottom-v-line"
    }), _react["default"].createElement("i", {
      className: "base-line left-bottom-h-line"
    }), _react["default"].createElement("i", {
      className: "base-line right-bottom-v-line"
    }), _react["default"].createElement("i", {
      className: "base-line right-bottom-h-line"
    }))), _react["default"].createElement("div", {
      className: "auth-qrcode-overlay",
      onClick: generate
    }, _react["default"].createElement(_Typography["default"], {
      component: "div",
      className: "auth-qrcode-refresh"
    }, state.loading ? _react["default"].createElement(_CircularProgress["default"], {
      color: "secondary"
    }) : _locale["default"][locale].refresh)))), showDownload && _react["default"].createElement(_Download["default"], {
      className: "download",
      title: downLoadTitle,
      locale: locale
    }), _react["default"].createElement("div", {
      className: "auth-open-wallet"
    }, _react["default"].createElement(_Button["default"], {
      href: getDeepLink(),
      target: "_blank",
      variant: "outlined",
      className: "auth-open-btn"
    }, _locale["default"][locale].open)));
  }

  if (state.status === 'scanned') {
    return _react["default"].createElement(Container, Object.assign({
      disableClose: disableClose
    }, rest), _react["default"].createElement("div", {
      className: "auth-close",
      onClick: cancel
    }, "\xD7"), _react["default"].createElement("div", {
      className: className
    }, _react["default"].createElement("div", {
      className: "auth-avatar"
    }, _react["default"].createElement(_success["default"], {
      color: "green"
    })), _react["default"].createElement(_Typography["default"], {
      component: "div",
      className: "auth-tip auth-tip--shout"
    }, _locale["default"][locale].scanned), _react["default"].createElement(_Typography["default"], {
      component: "div",
      className: "auth-tip auth-tip--confirm"
    }, messages.confirm), _react["default"].createElement("div", {
      className: "auth-action auth-action--reset"
    }, _react["default"].createElement(_Button["default"], {
      onClick: onGenerate
    }, _locale["default"][locale].switchAccount))));
  }

  if (state.status === 'error') {
    return _react["default"].createElement(Container, Object.assign({
      disableClose: disableClose
    }, rest), _react["default"].createElement("div", {
      className: "auth-close",
      onClick: cancel
    }, "\xD7"), _react["default"].createElement("div", {
      className: className
    }, _react["default"].createElement(_Typography["default"], {
      component: "div",
      className: "auth-tip auth-tip--shout"
    }, _locale["default"][locale].oops), _react["default"].createElement(_Typography["default"], {
      component: "div",
      className: "auth-tip auth-tip--confirm"
    }, state.error || _locale["default"][locale].error)));
  }

  if (state.status === 'succeed') {
    return _react["default"].createElement(Container, Object.assign({
      disableClose: disableClose
    }, rest), _react["default"].createElement("div", {
      className: "auth-close",
      onClick: cancel
    }, "\xD7"), _react["default"].createElement("div", {
      className: className
    }, _react["default"].createElement(_Typography["default"], {
      component: "p",
      className: "auth-tip auth-tip--success"
    }, messages.success)));
  } // This is not possible


  return null;
}

BasicAuth.propTypes = {
  onClose: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuccess: _propTypes["default"].func.isRequired,
  action: _propTypes["default"].string.isRequired,
  checkFn: _propTypes["default"].func.isRequired,
  locale: _propTypes["default"].oneOf(['en', 'zh']),
  prefix: _propTypes["default"].string,
  socketUrl: _propTypes["default"].string,
  tokenKey: _propTypes["default"].string,
  checkInterval: _propTypes["default"].number,
  checkTimeout: _propTypes["default"].number,
  qrcodeSize: _propTypes["default"].number,
  extraParams: _propTypes["default"].object,
  disableClose: _propTypes["default"].bool,
  messages: _propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    scan: _propTypes["default"].string.isRequired,
    confirm: _propTypes["default"].string.isRequired,
    success: _propTypes["default"].string.isRequired
  }).isRequired,
  showDownload: _propTypes["default"].bool
};
BasicAuth.defaultProps = {
  locale: 'en',
  prefix: '/api/did',
  socketUrl: '',
  tokenKey: '_t_',
  onClose: function onClose() {},
  onError: function onError() {},
  qrcodeSize: 210,
  checkInterval: 2000,
  checkTimeout: 60000,
  // 1 minute
  disableClose: false,
  extraParams: {},
  showDownload: true
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "basic__Container",
  componentId: "sc-1fn7cnc-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;box-sizing:border-box;padding:64px;@media (max-width:768px){padding:32px;overflow:hidden;.download{margin-top:16px !important;svg{width:120px !important;}.download-title{margin-bottom:0 !important;}}.auth-qrcode{.auth-qrcode-area{.base-line{display:none !important;}}}}@media (max-width:320px){.download{svg{width:100px !important;}}}.auth-title{font-weight:normal;width:100%;margin:0;padding:0;box-sizing:border-box;text-transform:capitalize;text-align:left;margin-bottom:2rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}.auth-title-center{text-align:center;}.auth-close{display:", ";position:absolute;top:1rem;right:1rem;color:#999999;font-size:2rem;line-height:1rem;cursor:pointer;user-select:none;}.auth-section{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;color:#999999;}.auth-qrcode{margin-top:2rem;position:relative;display:flex;flex-direction:column;align-items:center;.auth-qrcode-overlay{display:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:8rem;height:8rem;border-radius:4rem;background:#4e6af6;color:#ffffff;text-align:center;line-height:8rem;cursor:pointer;}.auth-qrcode-area{position:relative;.base-line{display:inline-block;position:absolute;background-color:#4e6af6;height:30px;width:6px;}.left-top-v-line{top:-15px;left:-15px;height:30px;width:6px;}.left-top-h-line{top:-15px;left:-15px;width:30px;height:6px;}.right-top-v-line{top:-15px;right:-15px;height:30px;width:6px;}.right-top-h-line{top:-15px;right:-15px;width:30px;height:6px;}.right-bottom-v-line{bottom:-15px;right:-15px;height:30px;width:6px;}.right-bottom-h-line{bottom:-15px;right:-15px;width:30px;height:6px;}.left-bottom-v-line{bottom:-15px;left:-15px;height:30px;width:6px;}.left-bottom-h-line{bottom:-15px;left:-15px;width:30px;height:6px;}}}.download{margin-top:32px;.download-title{font-size:0.8rem;text-align:center;}}.auth-qrcode--timeout{svg{opacity:0.3;z-index:1;}.auth-qrcode-overlay{display:block;z-index:99;display:flex;justify-content:center;align-items:center;}.auth-qrcode-refresh{display:flex;justify-content:center;align-items:center;}}.auth-avatar{margin-top:2rem;}.auth-tip{text-align:center;}.auth-tip--scan{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}.auth-tip--scan,.auth-tip--confirm{font-size:1rem;}.auth-tip--scan{text-align:left;width:100%;}.auth-tip--scan-center{text-align:center;}.auth-tip--shout{color:green;font-size:1.5rem;margin:1.5rem 0 1rem;}.auth-tip--confirm{margin-bottom:40px;}.auth-tip--success{margin-top:1rem;}.auth-open-wallet{display:none;margin:1rem 0 0.5rem;@media (max-width:768px){display:block;}.auth-open-btn{border-color:#4e6af6;text-transform:none;color:#4e6af6;}}"], function (props) {
  return props.disableClose ? 'none' : 'block';
});